import { useEffect, useRef, useState } from 'react';

const WHATSAPP_URL = 'https://wa.me/5535997383261?text=Ol%C3%A1%2C%20vim%20pelo%20site%20e%20gostaria%20de%20falar%20com%20o%20advogado%20criminalista%20Patrick%20Serafini';

const SERVICES = [
  {
    icon: 'ri-time-line',
    title: 'Flagrantes 24h',
    desc: 'Atendimento imediato em caso de prisão em flagrante, em qualquer horário.',
  },
  {
    icon: 'ri-file-search-line',
    title: 'Revisão Criminal',
    desc: 'Análise detalhada de condenações para buscar revisão e novos caminhos jurídicos.',
  },
  {
    icon: 'ri-scales-3-line',
    title: 'Audiência de Custódia',
    desc: 'Acompanhamento especializado na audiência para garantir seus direitos.',
  },
  {
    icon: 'ri-building-line',
    title: 'Acompanhamento em Delegacia',
    desc: 'Presença estratégica durante depoimentos e procedimentos na delegacia.',
  },
  {
    icon: 'ri-auction-line',
    title: 'Tribunal do Júri',
    desc: 'Defesa completa e técnica em processos julgados pelo Tribunal do Júri.',
  },
  {
    icon: 'ri-shield-user-line',
    title: 'Defesa em Processos de Maria da Penha',
    desc: 'Representação em processos envolvendo a Lei Maria da Penha.',
  },
  {
    icon: 'ri-medicine-bottle-line',
    title: 'Tráfico de Drogas',
    desc: 'Estratégias de defesa em processos de tráfico e crimes relacionados.',
  },
  {
    icon: 'ri-heart-pulse-line',
    title: 'Violência Doméstica',
    desc: 'Defesa ou representação em casos de violência doméstica e familiar.',
  },
];

export default function ServicesSection() {
  const sectionRef = useRef<HTMLElement>(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setInView(true); },
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="solucoes" ref={sectionRef} className="bg-bg-light py-16 md:py-28 px-4 md:px-6 lg:px-10">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-10 md:mb-14">
          <div>
            <span className="font-cinzel text-grey text-sm tracking-wide">Áreas de Atuação</span>
            <h2 className="font-cinzel font-bold text-navy text-3xl md:text-5xl lg:text-6xl mt-2 leading-tight">
              Soluções em
              <br />
              <em className="font-cinzel italic">Direito Criminal</em>
            </h2>
          </div>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {SERVICES.map((service, i) => (
            <div
              key={i}
              className={`group border border-navy rounded-2xl md:rounded-3xl overflow-hidden transition-all duration-500 hover:-translate-y-1 ${
                inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
              style={{ transitionDelay: `${i * 80}ms` }}
            >
              {/* Icon area */}
              <div className="bg-off-white h-40 md:h-48 flex items-center justify-center">
                <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-full bg-white/80">
                  <i className={`${service.icon} text-grey text-2xl md:text-3xl w-full h-full flex items-center justify-center`} />
                </div>
              </div>
              {/* Text area */}
              <div className="p-5 md:p-6">
                <h3 className="font-cinzel font-bold text-navy text-base md:text-lg">
                  {service.title}
                </h3>
                <p className="font-montserrat font-light text-grey text-sm mt-2 leading-relaxed line-clamp-3">
                  {service.desc}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="mt-10 md:mt-14 text-center">
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-green-cta text-navy font-montserrat font-semibold text-sm px-6 py-3 rounded-full hover:opacity-90 transition-opacity whitespace-nowrap"
          >
            <i className="ri-whatsapp-line w-4 h-4 flex items-center justify-center" />
            Falar com o Advogado no WhatsApp
          </a>
        </div>
      </div>
    </section>
  );
}